// extracted by mini-css-extract-plugin
var _1 = "Hc57MO__jgK3gUpQdukR";
export { _1 as "root" }
